import { render, staticRenderFns } from "./historyCard.vue?vue&type=template&id=5c2cb0bd&scoped=true"
import script from "./historyCard.vue?vue&type=script&lang=js"
export * from "./historyCard.vue?vue&type=script&lang=js"
import style0 from "./historyCard.vue?vue&type=style&index=0&id=5c2cb0bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2cb0bd",
  null
  
)

export default component.exports